import React from 'react'
import formatNumberCommas from 'Utils/formatNumberCommas'

const TotalPriceCell: React.FC<any> = props => {
	const { product, quantity } = props.row.original

	return (
		<React.Fragment>
			<div className="text-end">
				<div className="text-kumopack-grey-900 fw-bolder fs-4">
					{formatNumberCommas(quantity * product?.price ?? 0)}
				</div>
				<div>บาท</div>
			</div>
		</React.Fragment>
	)
}

export default TotalPriceCell
